import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { toast } from "react-toastify";
import Loader from "../../../components/Loader"; // Import Loader component
import OtpVerification from "./OtpVerification"; // Import the modal component
import ChangeEmailModal from "../../dashboard/Update-pending-verification/ChangeEmailModal"; // Import the new modal component
import { useSelector } from "react-redux";

function UpdatePendingVerification() {
    const { t } = useTranslation();
    const [isModalOpen, setIsModalOpen] = useState(false); // State to control modal visibility
    const [isChangeEmailModalOpen, setIsChangeEmailModalOpen] = useState(false); // State to control ChangeEmailModal visibility
    const [loading, setLoading] = useState(false); // State for loader
    const [email, setEmail] = useState(null); // State to store email
    const user = useSelector((state) => state.auth.user);
    const language = localStorage.getItem("i18nextLng"); // Get language from localStorage

    const openModal = () => setIsModalOpen(true);
    const closeModal = () => setIsModalOpen(false);
    const openChangeEmailModal = () => {
        setIsChangeEmailModalOpen(true); // Ensure this updates the state correctly
    };
    const closeChangeEmailModal = () => {
        setIsChangeEmailModalOpen(false); // Ensure this updates the state correctly
    };

    // Fetch email on component mount
    useEffect(() => {
        const fetchPersonalInfo = async () => {
            try {
                setLoading(true);
                const res = await axios.get(`/employee/get/${user?.userId}`);
                setEmail(res.data.response.email);
            } catch (err) {
                toast.error(t("Failed to fetch email. Please try again."));
            } finally {
                setLoading(false);
            }
        };
        if (user?.userId) {
            fetchPersonalInfo();
        }
    }, [user?.userId]);

    // Handle resend OTP
    const handleResendOTP = async () => {
        if (!email) {
            toast.error(t("Email not available. Please try again."));
            return;
        }
        try {
            setLoading(true);
            await axios.post("settings/generate-otp", {
                type: 4,
                email: email,
                lang: language,
            });
            toast.success(t("OTP sent successfully!"));
        } catch (err) {
            toast.error(t("Failed to send OTP. Please try again."));
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            {loading && <Loader />} {/* Show loader when loading */}
            <div style={{ 
                backgroundColor: "#e6f0ff", 
                padding: "15px 15px", 
                borderRadius: "6px", 
                boxSizing: "border-box",
                fontFamily: "Arial, sans-serif",
                color: "#1a1a1a",
            }}>
                <div style={{ 
                    display: "flex", 
                    alignItems: "center",
                    justifyContent: "flex-start",
                    marginBottom: "6px"
                }}>
                    <div style={{ 
                        backgroundColor: "#0052cc", 
                        borderRadius: "50%", 
                        width: "20px", 
                        height: "20px", 
                        display: "flex", 
                        alignItems: "center", 
                        justifyContent: "center", 
                        color: "white", 
                        fontWeight: "bold",
                        fontSize: "14px", 
                        marginRight: "6px"
                    }}>
                        i
                    </div>
                    <div style={{ fontWeight: "bold", fontSize: "16px", color: "#172b4d" }}>
                        {t("Update pending verification")}
                    </div>
                </div>
                <div style={{ fontSize: "14px", color: "#42526e", marginLeft: "25px" }}>
                    {t("Please verify your email address to continue using platform")}
                </div>
                <div style={{ display: "flex", gap: "8px", marginTop: "4px", marginLeft: "20px" }}>
                    <button style={{
                        backgroundColor: "transparent",
                        color: "#0052cc",
                        border: "none",
                        textDecoration: "underline",
                        fontWeight: "bold",
                        cursor: "pointer",
                        fontSize: "12px",
                        whiteSpace: "nowrap"
                    }} onClick={openModal}>
                        {t("Enter Verification Code")}
                    </button>
                
                    <button style={{
                        backgroundColor: "transparent",
                        color: "#0052cc",
                        border: "none",
                        textDecoration: "underline",
                        fontWeight: "bold",
                        cursor: "pointer",
                        fontSize: "12px",
                        whiteSpace: "nowrap"
                    }} onClick={() => {
                        openModal(); // Open the modal first
                        handleResendOTP(); // Then call the API
                    }}>
                        {t("Resend Verification Code")}
                    </button>

                    <button style={{
                        backgroundColor: "transparent",
                        color: "#0052cc",
                        border: "none",
                        textDecoration: "underline",
                        fontWeight: "bold",
                        cursor: "pointer",
                        fontSize: "12px",
                        whiteSpace: "nowrap"
                    }} onClick={openChangeEmailModal}> {/* Ensure this calls the correct function */}
                        {t("Change Email Address")}
                    </button>
                </div>
            </div>
            {isModalOpen && <OtpVerification onClose={closeModal} email={null} />} {/* Render modal if open */}
            {isChangeEmailModalOpen && <ChangeEmailModal email={email} onClose={closeChangeEmailModal} />} {/* Ensure this renders the modal when state is true */}
        </>
    );
}

export default UpdatePendingVerification;